module.exports = __webpack_public_path__ + "static/img/BELMONT-MDF.dad8e3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/BELMONT-MDF.png
// module id = Gsyt
// module chunks = 0